import React, { useEffect, useState } from "react";
// import { Container } from "react-bootstrap";
import Layout from "../../layout/Layout";
import img from '../../assets/images/blogImage.png';
import blogimg1 from '../../assets/images/blog-img1.webp';
import { Link } from 'react-router-dom';

import { connect } from "react-redux";
import { getBlogList } from "../../redux/actions/admin/adminBlogAction";
import { BASE_URLS } from "../../redux/constant";

import img2 from '../../assets/images/Blog.png';
import img2mob from '../../assets/images/Blog-mob.png';
const Blog = (props: any) => {
    interface BlogItem {
        heading:string;
        id:number;
        order: number;
        image: string;
        description: string;
        category: string;
    }
    const [blogData,setBlogData]=useState([])
    useEffect(()=>{
        props.getBlogList();
    },[])
    useEffect(() => {
        if (props.blogListData) {
            setBlogData(props.blogListData.blogs);
        }
      }, [props.blogListData]);
    
  
    const sortedBlogData = (blogData as BlogItem[]).sort((a, b) => a.order - b.order);
    const postsPerPage =props.blogListData&&props.blogListData.postPerPage?props.blogListData.postPerPage:10;
    const [currentPage, setCurrentPage] = useState(1);
  
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const currentPosts = sortedBlogData.slice(indexOfFirstPost, indexOfLastPost);
  return (
    <Layout>
        <div className="container-width mt-3">
                <div className="row flex-lg-row-reverse">
                    <div className="col-xl-6 text-center">
                        {/* desktop only */}
                        <img className=" mb-2 d-none d-xl-block mx-auto aboutImgDesk" src={img2} alt="Live Before You Leave" />
                    </div>
                      <div className="aboutUsMainCOntent col-xl-6">
                          {/* ipad/mobile only */}
                          <img className="img-fluid my-3 mx-auto rounded-circle  d-block d-xl-none" src={img2mob} alt="Live Before You Leave" />
                          <h2 className="heading-title text-center text-xl-start">Live Before You Leave</h2>
                          <div className=" text-white">
                              <div>
                                  <p className="mb-0">Live Before You Leave is BeyondBox's space for
                                      reflection, learning, and inspiration. It is a place to explore
                                      how to live with greater intention today, while thoughtfully
                                      preparing for what we leave behind. Through practical
                                      insights and reflective writing, the blog supports you in
                                      making the most of your time, your relationships, and the
                                      life you are building. Here, you will find guidance on using
                                      BeyondBox with purpose, alongside broader reflections
                                      on legacy, wellbeing, financial clarity, and personal
                                      growth. From caring for your mental and physical health,
                                      to planning responsibly for the future, to finding joy
                                      through experiences, stories, and adventure, each piece is
                                      designed to support a life lived fully and consciously.
                                      Live Before You Leave is not about perfection or
                                      productivity. It is about awareness, gratitude, and choice.
                                      A reminder that legacy is shaped not only by what we
                                      leave behind, but by how we live while we are here.</p>
                              </div>
                          </div>
                      </div>
                </div>
            </div>
        <div className="blog-container">
            <div className="babackground-color">
                <div className="container-width-80">
                    <div>
                        {currentPosts.map(blog => (
                            <div key={blog.id} className="bg-Main-Content text-white mb-5">
                                <div className="mobile-card-box">
                                    <div className="row">
                                        <div className="col-lg-3 blog-img-cover">
                                            <img  src={`${BASE_URLS.BASE_URL}/user-box-files/resource?key=${blog.image}`} alt="" />
                                        </div>
                                        <div className="col-lg-9 pl-35 plx-0 mtx-15">
                                            <h3 className="theme-color" style={{wordWrap:'break-word'}}>{blog.heading}</h3>
                                            {/* <p  >{blog.description.length <= 300 ? blog.description : blog.description.slice(0, 300) + '...'}</p> */}
                                            <p className="blog-description" style={{ wordWrap: 'break-word' }}>
                                                {blog.description.length <= 300 ? (
                                                    <span dangerouslySetInnerHTML={{ __html: blog.description}}></span>
                                                ) : (
                                                    <span dangerouslySetInnerHTML={{ __html: blog.description.slice(0, 300) + '...' }}></span>
                                                )}
                                            </p>
                                            {/* Assuming you want to link to individual blog posts */}
                                            
                                            <Link to={`/admin-blog-detail/${blog.id}`} className="view-post-link">
                                                View Post
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}


    <div>
        {blogData.length > postsPerPage && (
            <ul className="pagination justify-content-center">
                {/* Start button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button onClick={() => setCurrentPage(1)} className="page-link">&laquo;</button>
                </li>
                
                {/* Previous button */}
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button onClick={() => setCurrentPage(currentPage - 1)} className="page-link">&lsaquo;</button>
                </li>
                
                {/* Pagination buttons */}
                {Array.from({ length: Math.min(3, Math.ceil(blogData.length / postsPerPage)) }, (_, i) => {
                    const pageNumber = currentPage - 1 + i;
                    if (pageNumber >= 1 && pageNumber <= Math.ceil(blogData.length / postsPerPage)) {
                        return (
                            <li key={i} className={`page-item ${currentPage === pageNumber ? 'active' : ''}`}>
                                <button onClick={() => setCurrentPage(pageNumber)} className="page-link">{pageNumber}</button>
                            </li>
                        );
                    } else {
                        return null; // Render nothing for excess page numbers or negative page numbers
                    }
                })}
                
                {/* Next button */}
                <li className={`page-item ${currentPage === Math.ceil(blogData.length / postsPerPage) ? 'disabled' : ''}`}>
                    <button onClick={() => setCurrentPage(currentPage + 1)} className="page-link">&rsaquo;</button>
                </li>
                
                {/* End button */}
                <li className={`page-item ${currentPage === Math.ceil(blogData.length / postsPerPage) ? 'disabled' : ''}`}>
                    <button onClick={() => setCurrentPage(Math.ceil(blogData.length / postsPerPage))} className="page-link">&raquo;</button>
                </li>
            </ul>
        )}
    </div>



                    </div>
                </div>
            </div>
            
            {/* <div className="bg-img">
                <div className="container-width-80 py-container mb-5"> 
                    <h2 className="heading-title"> <span className="theme-color">Top 10 bucket list places to visit</span>  </h2>
        
                    <div className="bg-Main-Content text-white ">
                        <div className="mobile-card-box">
                            <p className="mb-md-5">
                                Meet Bebo, BeyondBox's In-House Blogger Bot and the newest member of our team! Crafted with
                                creativity and passion, Bebo is here to enrich your BeyondBox experience. Powered by the latest in AI
                                technology, Bebo brings a wealth of knowledge to our blog, offering our readers not just content, but an
                                experience. With access to extensive information and a unique ability to generate insightful, engaging
                                articles, Created to be your guide, muse, and friend, Bebo embodies the essence of.
                            </p>
                        </div>
                        <div className="mb-md-5 mobile-card-box">
                            <h5> <span className="theme-color">Heading in different colour</span> </h5>
                            <p>
                            BeyondBox's In-House Blogger Bot and the newest member of our team! Crafted with creativity and
                            passion, Bebo is here to enrich your BeyondBox experience. Powered by the latest in AI technology,
                            Bebo brings a wealth of knowledge to our blog, offering our readers not just content, but an experience.
                            With access to extensive information and a unique ability to generate insightful, engaging articles,
                            Created to be your guide, muse, and friend, Bebo embodies the essence of .
                            </p>
                        </div>
                        <div className="mb-md-5 mobile-card-box">
                            <h5> <span className="theme-color">Heading in different colour</span> </h5>
                            <p>
                            BeyondBox's In-House Blogger Bot and the newest member of our team! Crafted with creativity and
                            passion, Bebo is here to enrich your BeyondBox experience. Powered by the latest in AI technology,
                            Bebo brings a wealth of knowledge to our blog, offering our readers not just content, but an experience.
                            With access to extensive information and a unique ability to generate insightful, engaging articles,
                            Created to be your guide, muse, and friend, Bebo embodies the essence of .
                            </p>
                        </div>
                        
                    </div>
                </div>
            </div> */}

            {/* <div className="bg-img">
                <div className="container-width-80 py-container">
                    <h2 className="theme-color">
                    Related Posts</h2>
                    <div className="bg-Main-Content text-white mb-5">
                        <div className="row">
                            <div className="col-md-4 col-lg-3 blog-img-cover">
                                <img src={blogimg1} alt="" />
                            </div>
                            <div className="col-md-8 col-lg-9 pl-50 plx-0 mtx-15">
                                <h3 className="theme-color">
                                    A guide to creating your first BeyondBox
                                </h3>
                                <p>
                                    Meet Bebo, BeyondBox's In-House Blogger Bot and the newest member of our team!
                                    Crafted with creativity and passion, Bebo is here to enrich your BeyondBox
                                    experience. Powered by the latest in AI technology, Bebo brings a wealth of
                                    knowledge to our blog, offering our readers not just content, but an experience. With
                                    access to extensive information and a unique ability to generate insightful, engaging
                                    articles, Created to be your guide, muse, and friend, Bebo embodies the essence of
                                </p>
                                <Link to="#" className="view-post-link">
                                    View Post
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="bg-Main-Content text-white mb-5">
                        <div className="row">
                            <div className="col-md-4 col-lg-3 blog-img-cover">
                                <img src={blogimg1} alt="" />
                            </div>
                            <div className="col-md-8 col-lg-9 pl-50 plx-0 mtx-15">
                                <h3 className="theme-color">
                                    A guide to creating your first BeyondBox
                                </h3>
                                <p>
                                    Meet Bebo, BeyondBox's In-House Blogger Bot and the newest member of our team!
                                    Crafted with creativity and passion, Bebo is here to enrich your BeyondBox
                                    experience. Powered by the latest in AI technology, Bebo brings a wealth of
                                    knowledge to our blog, offering our readers not just content, but an experience. With
                                    access to extensive information and a unique ability to generate insightful, engaging
                                    articles, Created to be your guide, muse, and friend, Bebo embodies the essence of
                                </p>
                                <Link to="#" className="view-post-link">
                                    View Post
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    </Layout>
  );
};
const mapDispatchToProps = (dispatch: any) => ({
    getBlogList: (data: any) => dispatch(getBlogList(data)),
  });
  const mapStateToProps = (state: any) => {
    return {
      blogListData: state.AdminBlogReducer && state.AdminBlogReducer.blogListData ? state.AdminBlogReducer.blogListData : null,
    };
  };
  export default connect(mapStateToProps, mapDispatchToProps)(Blog);